import { useEffect, useRef, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { enGB, nl } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import { useTranslation } from "i18n";

registerLocale("en", enGB);
registerLocale("nl", nl);

const toValidDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const EntryFeeDateField = ({
  label,
  mandatory,
  value,
  onChange,
  onBlur,
  error,
  minDate,
  maxDate,
  openToDate,
  showYearSelect = false,
  placeholder,
}) => {
  const { t, locale } = useTranslation();
  const pickerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const selected = toValidDate(value);

  useEffect(() => {
    const media = window.matchMedia("(max-width: 800px)");
    const sync = () => setIsMobile(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  return (
    <div className="entry-fee-date">
      {label && (
        <label>
          {mandatory && <span className="mandatory-sign">*</span>}
          {label}
        </label>
      )}
      <div className={`entry-fee-date__control${error ? " is-error" : ""}`}>
        <DatePicker
          ref={pickerRef}
          selected={selected}
          onChange={onChange}
          onBlur={onBlur}
          minDate={minDate}
          maxDate={maxDate}
          openToDate={selected || openToDate}
          dateFormat="dd/MM/yyyy"
          placeholderText={placeholder || t("entryFee.form.datePlaceholder")}
          locale={locale === "nl" ? "nl" : "en"}
          showMonthDropdown={showYearSelect}
          showYearDropdown={showYearSelect}
          dropdownMode="select"
          yearDropdownItemNumber={100}
          scrollableYearDropdown
          showPopperArrow={false}
          withPortal={isMobile}
          calendarClassName="entry-fee-date__calendar"
          popperClassName="entry-fee-date__popper"
          popperPlacement="bottom-start"
          popperProps={{ strategy: "fixed" }}
          autoComplete="off"
          fixedHeight
        />
        <button
          type="button"
          className="entry-fee-date__icon"
          onClick={() => pickerRef.current?.setOpen(true)}
          aria-label={t("entryFee.form.openCalendar")}
        >
          <CalendarMonthIcon fontSize="small" />
        </button>
      </div>
      {error && <span className="error-msg">{error}</span>}
    </div>
  );
};

export default EntryFeeDateField;
